// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skeleton Loading Styles */

.skeleton-line,
.skeleton-circle,
.skeleton-pulse {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.04) 25%,
    rgba(255, 255, 255, 0.16) 50%,
    rgba(255, 255, 255, 0.04) 75%
  );
  background-size: 220% 100%;
  animation: shimmer 1.35s ease-in-out infinite;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.skeleton-circle {
  border-radius: 50%;
  width: 12px;
  height: 12px;
}

.skeleton-text-stack {
  display: flex;
  flex-direction: column;
}

.skeleton-badge-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.skeleton-pill {
  border-radius: 999px;
}

.skeleton-image {
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
}

.skeleton-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  padding: 18px;
  backdrop-filter: blur(6px);
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Chart Skeleton */
.chart-skeleton {
  padding: 20px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.skeleton-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.skeleton-chart-body {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.skeleton-y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50px;
  padding: 10px 0;
}

.skeleton-chart-area {
  flex: 1 1;
  min-height: 300px;
}

.skeleton-x-axis {
  display: flex;
  justify-content: space-between;
  padding: 0 60px;
  margin-top: 12px;
}

.skeleton-legend {
  display: flex;
  gap: 24px;
  margin-top: 20px;
  justify-content: center;
}

.skeleton-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Table Skeleton */
.table-skeleton {
  width: 100%;
}

.skeleton-table-row {
  display: flex;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.skeleton-table-cell {
  flex: 1 1;
}

/* Card Skeleton */
.card-skeleton {
  padding: 20px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.card-skeleton .skeleton-title {
  margin-bottom: 16px;
}

.card-skeleton .skeleton-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Rows/Table Skeleton */
.skeleton-table {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.skeleton-table-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/component/Loading/Skeleton.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;;;EAGE;;;;;GAKC;EACD,0BAA0B;EAC1B,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,SAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB","sourcesContent":["/* Skeleton Loading Styles */\n\n.skeleton-line,\n.skeleton-circle,\n.skeleton-pulse {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.04) 25%,\n    rgba(255, 255, 255, 0.16) 50%,\n    rgba(255, 255, 255, 0.04) 75%\n  );\n  background-size: 220% 100%;\n  animation: shimmer 1.35s ease-in-out infinite;\n  border-radius: 4px;\n  position: relative;\n  overflow: hidden;\n}\n\n.skeleton-circle {\n  border-radius: 50%;\n  width: 12px;\n  height: 12px;\n}\n\n.skeleton-text-stack {\n  display: flex;\n  flex-direction: column;\n}\n\n.skeleton-badge-row {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.skeleton-pill {\n  border-radius: 999px;\n}\n\n.skeleton-image {\n  position: relative;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.skeleton-card {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  padding: 18px;\n  backdrop-filter: blur(6px);\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Chart Skeleton */\n.chart-skeleton {\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.skeleton-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.skeleton-chart-body {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.skeleton-y-axis {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 50px;\n  padding: 10px 0;\n}\n\n.skeleton-chart-area {\n  flex: 1;\n  min-height: 300px;\n}\n\n.skeleton-x-axis {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 60px;\n  margin-top: 12px;\n}\n\n.skeleton-legend {\n  display: flex;\n  gap: 24px;\n  margin-top: 20px;\n  justify-content: center;\n}\n\n.skeleton-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Table Skeleton */\n.table-skeleton {\n  width: 100%;\n}\n\n.skeleton-table-row {\n  display: flex;\n  gap: 16px;\n  padding: 12px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.skeleton-table-cell {\n  flex: 1;\n}\n\n/* Card Skeleton */\n.card-skeleton {\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.card-skeleton .skeleton-title {\n  margin-bottom: 16px;\n}\n\n.card-skeleton .skeleton-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Rows/Table Skeleton */\n.skeleton-table {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.skeleton-table-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
